$(function () {
  'use strict';

  /**
   * 文字列を切り捨てる
   *
   * @param   {String}  text
   * @return  {String}  text
   *
   * String オブジェクトの拡張は xeditable でエラーになるため通常のメソッドで定義
   */
  function truncate(text, n) {
    return (text.length > n) ? text.slice(0, n - 1) + '…' : text;
  }

  /**
   * 製品情報作成
   *
   * @param   {object}  ui
   * @return  {jQuery}  $(product)
   */
  function buildProduct(ui) {
    var productName = truncate(ui.item.value, 30);
    var safeName = escapeHTML(productName);
    var safeProductId = escapeHTML(ui.item.product_id);
    var safeImageUrl = escapeHTML(ui.item.url);
    var safeItemId = escapeHTML(String(ui.item.id));

    var image, name, deleteButton, fileForm, product;

      image = '<div class="media-product__image"><img src="' + safeImageUrl + '" alt="' + safeName + '" /></div>';
      name = '<div class="media-product__name"><p>' + safeName + '</p></div>';
      deleteButton = '<div class="media-product__delete"><div class="js-media-product-delete"><a><i class="fa fa-times" aria-hidden="true"></i></a></div></div>';
      fileForm = '<input type="hidden" name="report_item[product][' + safeItemId + '][product_ids][]" value="' + safeProductId + '">';
      product = '<li class="media-product__wrapper js-media-product-item"><div class="media-product__item">' + image + name + deleteButton + fileForm + '</div></li>';

    return $(product);
  }

  /**
   * Amazonに存在しないオリジナル製品作成
   *
   * @param   {String}  productName
   * @param   {integer} itemId
   * @return  {jQuery}  $(product)
   */
  function buildOriginalProduct(productName, itemId) {
    if (productName) {
      var name, deleteButton, fileForm, product;

      name = '<div class="media-product__name"><p>' + productName + '</p></div>';
      deleteButton = '<div class="media-product__delete"><div class="js-media-product-delete"><a><i class="fa fa-times" aria-hidden="true"></i></a></div></div>';
      fileForm = '<input type="hidden" name="report_item[product][' + itemId + '][product_names][]" value="' + productName + '">';
      product = '<li class="media-product__wrapper js-media-product-item"><div class="media-product__item">' + name + deleteButton + fileForm + '</div></li>';

      return $(product);
    }
  }

  function appendProduct($searchField, $productList) {
    if ($searchField.length && $productList.length) {
      var text = escapeHTML($searchField.val().trim());
      var itemId = $searchField.data('item-id');
      if (text) {
        var $product = buildOriginalProduct(text, itemId);

        if ($product !== undefined && $product.length) {
          $productList.append($product);
        }
      }
    }

    // 検索フィールドを空に
    $searchField.val('');
  }


  //サニタイジング用の処理
  function escapeHTML(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function unescapeHTML(str) {
    return str
    .replace(/&lt;/g,'<')
    .replace(/&gt;/g,'>')
    .replace(/&amp;/g,'&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'');
  }

  $(function () {
    var $form = $('form[data-report-post-form]');
    var $searchProducts = $form.find('.js-book-search');

    $searchProducts.each(function () {
      var $searchField = $(this).find('.js-media-product-name');

      var timerId = null;

      $searchField.autocomplete({
        source: function (request, response) {
          if (!request.term) {
            $(this).attr('autocomplete', 'off');
          }

          if (timerId) clearTimeout(timerId)

          timerId = setTimeout( function () {
            $.get('/api/v1/books', {keyword: request.term}, function (data) {
              response(data.filter(function(value){ return value.book.image_url != undefined }).map(function (value) {
                var productId = value.book.product_id;
                var productName = unescapeHTML(value.book.name);
                var imageUrl = value.book.image_url;
                // HTML文字列に埋め込む値はescapeHTMLでXSS対策を行う
                var safeName = escapeHTML(productName);
                var safeImageUrl = escapeHTML(imageUrl);

                return ({
                  label: ''
                  + '<div class="product-image">'
                  + '<img class="object-fit-images object-fit-images--cover" alt="' + safeName + '" width="50" height="50" src="' + safeImageUrl + '">'
                  + '</div>'
                  + '<div class="product-desc">'
                  + '<p class="product-name">' + safeName + '</p>'
                  + '</div>',
                  id: $searchField.data('item-id'),
                  product_id: productId,
                  value: productName,
                  url: imageUrl
                });
              }));
            });
          }, 400);
        },

        create: function () {
          // aware tap twice (double tap) on iOS
          if (navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iOS/) || navigator.userAgent.match(/Android/)) {
            $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
          }

          $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
            return $('<li>')
            .attr('data-value', item.value)
            .attr('data-url', item.url)
            .attr('data-cy', 'report-item-product-list-item')
            .addClass('list-group-item list-autocomplete-menu')
            .append('<a style="display: block; width: 100%;" href="javascript:void(0)">' + item.label + '</a>')
            .appendTo(ul);
          };
        },

        select: function (event, ui) {
          var $productList = $(this).closest('.js-book-search').find('.js-media-product-list');

          // プレビュー表示
          var $product = buildProduct(ui);
          if ($product.length && $productList.length) {
            $productList.append($product);
          }

          // 検索フィールドを空に
          $searchField.val('');
          return false;
        },
        autoFocus: false,
        delay: 100,
        minLength: 1
      });
    });

    $form.on('click', '.js-media-product-add', function () {
      var $searchField = $(this).prev('.js-media-product-name');
      var $productList = $(this).closest('.js-book-search').find('.js-media-product-list');

      appendProduct($searchField, $productList);
      return false;
    });

    // Enter key でのsubmitの禁止
    $form.on('keypress', '.js-book-search', function (e) {
      if (e.keyCode === 13) {
        var $searchField = $(this).prev('.js-media-product-name');
        var $productList = $(this).closest('.js-book-search').find('.js-media-product-list');

        appendProduct($searchField, $productList);
        return false;
      }
    });

    // 商品削除
    $form.on('click', '.js-media-product-delete', function () {
      var $preview = $(this).closest('.js-media-product-item');
      $preview.remove();
    });

    //Extension
    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
      return $('<li>').data('item.autocomplete', item).append($('<a>').html(item.label)).appendTo(ul);
    };

    $.ui.autocomplete.prototype._resizeMenu = function () {
      var ul = this.menu.element;
      ul.outerWidth(this.element.outerWidth());
    };
  });
});
